import React, { Component } from 'react';
import Favicon from 'react-favicon';
import favicon from '../../assets/images/prudential_web_icon_16x16.ico';
import logoImg from '../../assets/images/logo.png';

import '../../index.css';

class Header extends Component {
  constructor(props) {
    super(props);
    this.state = {
      hovered: false,
      icon: props.icon,
      color: props.color,
      hoverColor: props.hoverColor,
      onClick: props.onClick,
      children: props.children,
      partner: props.partner,
      disable: props.disable,
      image: props.image,
    };
    this.onClick = this.onClick.bind(this);
    this.onMouseOver = this.onMouseOver.bind(this);
    this.onMouseOut = this.onMouseOut.bind(this);

    //Design Variables
    this.configurable = {
      logoSrc: logoImg,
      logoSize: '160px',
    };
  }

  onClick() {
    console.log('clicked');
  }
  onMouseOver() {
    console.log('hover ');
    this.setState({ hovered: true });
  }

  onMouseOut() {
    this.setState({ hovered: false });
  }

  render() {
    return (
      <div className="Header row">
        <Favicon url={favicon} />

        <div className="col-2 ">
          {
            //previous link
            this.props.previous && this.props.previous
          }
        </div>
        <div className="col-8 text-center logo">
          {/* <img
            alt=""
            src={this.configurable.logoSrc}
            width={this.configurable.logoSize}
            className="img-responsive"
          /> */}
        </div>
        <div className="col-2 align-middle right">
          {
            //next link
            this.props.next && this.props.next
          }
        </div>
      </div>
    );
  }
}

export default Header;
